export function resolveStructuredData(structuredDataString) {
  if (structuredDataString === void 0) {
    structuredDataString = '{}';
  }

  try {
    var dataObject = JSON.parse(structuredDataString);
    return clearEmptyFields({
      dataObject: dataObject
    });
  } catch (error) {
    return '{}';
  }
}

function clearEmptyFields(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$dataObject = _ref.dataObject,
      dataObject = _ref$dataObject === void 0 ? {} : _ref$dataObject,
      containerObject = _ref.containerObject,
      containerKey = _ref.containerKey;

  if (!dataObject) {
    return '{}';
  }

  Object.entries(dataObject).forEach(function (_ref2) {
    var key = _ref2[0],
        val = _ref2[1];

    if (val && typeof val === 'object') {
      clearEmptyFields({
        dataObject: val,
        containerObject: dataObject,
        containerKey: key
      });
    } else {
      if (!val) {
        if (isKeyRequired(key, containerObject && containerObject[containerKey])) {
          delete containerObject[containerKey];
        } else {
          delete dataObject[key];
        }
      }
    }
  });
  return JSON.stringify(dataObject);
}

function isKeyRequired(key, container) {
  var requiredKeys = ['url', 'contentUrl'];

  if (key === 'name') {
    if (requiredKeys.includes(Object.keys(container))) {
      return false;
    }
  }

  return requiredKeys.includes(key);
}